import React from 'react';
import { Map } from './Map/Map';
import { HowToGetThere } from './HowToGetThere/HowToGetThere';
import styles from './InPersonLocation.module.scss';
import { Address } from './Address/Address';
import { Divider } from '@eventbrite/marmalade';

interface Props {
  venueMultilineAddress?: string[];
  venueName?: string;
  location: {
    latitude: number;
    longitude: number;
  };
  hasMap?: boolean;
  gMapsApiKey: string;
}

export const InPersonLocation: React.FC<Props> = (props) => {
  return (
    <div className={styles.inPersonEventLocation}>
      <div className={styles.address}>
        <Address venueMultilineAddress={props.venueMultilineAddress} venueName={props.venueName} />
      </div>
      <Divider className={styles.divider} />
      <div className={styles.howToGetThere}>
        <HowToGetThere location={props.location} />
      </div>
      <div className={styles.map}>
        {props.hasMap && <Map location={props.location} gMapsApiKey={props.gMapsApiKey} />}
      </div>
    </div>
  );
};
